import { render, staticRenderFns } from "./ModalCarrousel.vue?vue&type=template&id=4282c9d0"
import script from "./ModalCarrousel.vue?vue&type=script&lang=js"
export * from "./ModalCarrousel.vue?vue&type=script&lang=js"
import style0 from "./ModalCarrousel.vue?vue&type=style&index=0&id=4282c9d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports